
; $( function ( $ ) {
	$( '.counter' ).counterUp( {
		delay: 5,
		time: 3000
	} );
} );